import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { RepLIProviderTextField } from '../../../components';
import useStyles from "./Common.style";
import { fertilityPreservationMethods } from '../../../data/db';
import { arrayOfNumbers } from '../../../services/util.service';
import { AppSelect } from './ProviderInputComponents';

const PatientFertilityPreservationInformationForm = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [autoUpdate, setAutoUpdate] = useState(false);

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstYear = birthYear + 15;
    let currentYear = new Date(Date.now()).getFullYear();
    let methodYears = arrayOfNumbers(firstYear, currentYear - firstYear + 1);

    useEffect(() => {
        if (props.submitted) props.validator.showMessages();
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.submitted, props.validator, props.fertilityPreservationMethods]);

    return (
        <Grid container className={classes.questionnaireContainer}>
            {props.fertilityPreservationMethods.map((method, i) => {
                return (
                    <Grid container spacing={1} className={classes.questionnaireItem}>
                        <Grid item xs={12} className={classes.questionnaireItemHeader}>
                            <span>{t('common.substantive.method')} #{i + 1}</span>
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFertilityPreservationMethodDelete(i)}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={method.method === 'Other' ? 6 : 12}>
                            <FormControl
                                variant="outlined"
                                fullWidth
                                className={classes.formControl}
                                error={props.submitted && !props.validator.fieldValid(`fertility_preservation_#${i + 1}_method`)}
                            >
                                <InputLabel id="fertilityPreservationMethodLabel">{`${t('common.substantive.method')}*`}</InputLabel>
                                <Select
                                    labelId="fertilityPreservationMethodLabel"
                                    label={t('common.substantive.method')}
                                    value={method.method}
                                    onChange={props.onDataChange(i, 'method')}
                                >
                                    {['None', ...fertilityPreservationMethods].map(method =>
                                        <MenuItem key={method} value={method}>{method}</MenuItem>
                                    )}
                                </Select>
                                <FormHelperText>{props.validator.message(`fertility_preservation_#${i + 1}_method`, method.method, 'required')}</FormHelperText>
                            </FormControl>
                        </Grid>
                        {method.method === 'Other' &&
                            <Grid item xl={4} md={6}>
                                <RepLIProviderTextField
                                    label={`${t('repliQuestionnaire.label.specifyMethod')}*`}
                                    value={method.otherMethod}
                                    onChange={props.onMethodChange(i)}
                                    error={props.submitted && !props.validator.fieldValid(`fertility_preservation_#${i + 1}_other_method`)}
                                    helperText={props.validator.message(`fertility_preservation_#${i + 1}_other_method`, method.otherMethod, `otherFertilityMethod:${method.method}`)}
                                />
                            </Grid>
                        }
                        <Grid item xl={4} md={6} className={classes.appSelectGridItem}>
                            <Box display={method.method === 'None' || method.method === '' ? 'none' : 'block'}>
                                <AppSelect
                                    id={`fromYear${i + 1}`}
                                    label={`${t('common.preposition.from')}*`}
                                    value={method.yearFrom}
                                    items={methodYears}
                                    onChange={props.onDataChange(i, 'yearFrom')}
                                    error={props.submitted && !props.validator.fieldValid(`fertilitypreservationmethodFromyear${i}`)}
                                    helperText={props.validator.message(`fertilitypreservationmethodFromyear${i}`, method.yearFrom, `period_year:${method.method}`)}
                                    fullWidth
                                />
                            </Box>
                        </Grid>
                        <Grid item xl={4} md={6} className={classes.appSelectGridItem}>
                            <Box display={method.method === 'None' || method.method === '' ? 'none' : 'block'}>
                                <AppSelect
                                    id={`toYear${i + 1}`}
                                    label={`${t('common.preposition.to')}*`}
                                    value={method.yearTo}
                                    items={[...methodYears, 'Current method']}
                                    onChange={props.onDataChange(i, 'yearTo')}
                                    error={props.submitted && !props.validator.fieldValid(`fertilitypreservationmethodToyear${i}`)}
                                    helperText={props.validator.message(`fertilitypreservationmethodToyear${i}`, method.yearTo, `period_year:${method.method}`)}
                                    fullWidth
                                />
                            </Box>
                        </Grid>
                    </Grid>
                )
            })}
            <Grid item xs={12}>
                <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={props.onFertilityPreservationMethodAdd}
                >
                    {t('module.provider.addPatient.form.button.addFertilityPreservationMethod')}
                </Button>
            </Grid>
        </Grid>
    )
};

export default PatientFertilityPreservationInformationForm;